var $81e234215c31d18e$exports = {};
$81e234215c31d18e$exports = {
    "clear": `Ryd`,
    "invalid": `(ugyldig)`,
    "loading": `Indl\xe6ser ...`,
    "noResults": `Ingen resultater`,
    "valid": `(gyldig)`
};


export {$81e234215c31d18e$exports as default};
//# sourceMappingURL=da-DK.mjs.map
